// extracted by mini-css-extract-plugin
module.exports = {"container":"_19Kc6reXLs_Y5Bp9qkyoRQ","groupsList":"_3zIsJnf-miaV1pZqEyHkO7"};